Namespace 'Customer.Ticket.SkyChile'

class Customer.Ticket.SkyChile.ExternalTicket extends Backbone.Model

  defaults:
    associatedCEMTicket: null

  hasCEMChannel: ->
    @get('touchpoint').channel in @_CEMChannels()

  _CEMChannels: ->
    ['twitter', 'facebook', 'linkedin', 'instagram', 'email']



class Customer.Ticket.SkyChile.ExternalTicketCollection extends Backbone.Collection
  model: Customer.Ticket.SkyChile.ExternalTicket

  fetchAssociatedCEMTickets: ->
    ids = @_externalTicketsInCEM().map((externalTicket) -> externalTicket.get('ticketId'))
    @_findTicketsById(ids)

  _externalTicketsInCEM: =>
    @filter((externalTicket) -> externalTicket.hasCEMChannel())

  _findTicketsById: (ids) ->
    ticketCollection = new Customer.TicketSummaryCollection()
    ticketCollection.fetchForExternalTickets
      ids: ids
      success: (tickets) => @_setAssociatedCEMTickets(tickets)
      error: -> showError(I18n.t('customer.ticket.external_tickets.error'))

  _setAssociatedCEMTickets: (tickets) ->
    @each((externalTicket) ->
      keepconTicket = tickets.findWhere(id: parseInt(externalTicket.get('ticketId')))
      externalTicket.set("associatedCEMTicket", keepconTicket)
    )
